import { Box, Button, Divider, IconButton, Stack, Typography } from "@mui/material";
import React, { Fragment } from "react";
import { useNavigateToTop } from "../../libs/useNavigateToTop";
import AppBarMenu from "./Menu";
import AppBarRoot from "./Root";
import jsPDF from "jspdf";
import { ArrowBack, Save, ThumbDown, ThumbUp } from "@mui/icons-material";

export const VoteIndicator = ({ votes }) => {
  /** looks like a fraction with the upVotes and upote icon on the top and downVotes and downvote icon non the bottom */

  return (
    <Stack direction={"column"} spacing={0}
    style={{alignItems: "center",
      padding: "0.5rem",
    }}
    >
      <Stack 
          direction="row"
          style={{
            alignItems: "center"
          }}
          spacing={1}>
        <ThumbUp
        style={{
          fontSize: "1rem"
        }}
        />
        
      <Typography>{(votes.upVotes)? votes.upVotes.length: 0}</Typography>
      </Stack>
      <Typography style={{
        fontSize: "0.6rem"
      }} >VOTES</Typography>
      <Stack 
          direction="row"
          style={{
            alignItems: "center"
          }}
          spacing={1}>
        <ThumbDown
        style={{
          fontSize: "1rem"
        }}
        />
        <Typography>{(votes.downVotes)? votes.downVotes.length: 0}</Typography>
        </Stack>
    </Stack>
  );
}
function AppBarGuide({ title = "Guide", canSave, onSave, allowVoting =true, onUpvote, onDownvote, votes = {upVotes: 0, downVotes: 0}}) {
  const navigate = useNavigateToTop();


  return (
    <AppBarRoot
      startAction={
        <Stack direction={"row"} spacing={2}>
          {/* <AppBarMenu /> */}
          {/* Back button */}
          <IconButton onClick={() => navigate(-1)}
          color="secondary">
            <ArrowBack />
          </IconButton>
          <Typography
            onClick={() => navigate("/")}
            variant="h5"
            style={{ alignSelf: "center", color: "white" }}
          >
            {title}
          </Typography>
        </Stack>
      }
      endAction={
        <Stack direction={"row"} spacing={1}>
          {allowVoting && (
            <Fragment>
          <IconButton onClick={onUpvote}
          color="secondary">
            <ThumbUp />
          </IconButton>
          <IconButton onClick={onDownvote}
          color="secondary">
            <ThumbDown />
          </IconButton>
          </Fragment>
          )}
          <Divider orientation="vertical" flexItem
          style={{
            margin: "0.75rem"
          
          }} 
          
          />
          <VoteIndicator votes={votes} />

        </Stack>
      }
    />
  );
}

export default AppBarGuide;
